module.exports = __webpack_public_path__ + "static/media/Glalie_gaussian2.ae09e1c7.png";